/**
 * Game lobby — game selection and ready-up controls.
 */

import { Hash, type LucideIcon } from "lucide-react";
import { SUPPORTED_GAMES, type GameMeta } from "@/lib/gameKinds";

interface GameLobbyProps {
  selectedGame: string | null;
  onSelectGame: (gameType: string) => void;
}

const ICON_MAP: Record<string, LucideIcon> = {
  Hash,
};

export function GameLobby({ selectedGame, onSelectGame }: GameLobbyProps) {
  return (
    <div>
      <h3 className="mb-3 text-sm font-semibold uppercase tracking-wider text-muted-foreground">
        Available Games
      </h3>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {SUPPORTED_GAMES.map((game) => {
          const Icon = ICON_MAP[game.icon] ?? Hash;
          const isSelected = selectedGame === game.id;

          return (
            <button
              key={game.id}
              onClick={() => onSelectGame(game.id)}
              className={`flex items-start gap-3 rounded-xl border p-4 text-left transition-all ${
                isSelected
                  ? "border-primary bg-primary/10 ring-1 ring-primary/30"
                  : "border-border bg-card hover:border-primary/50 hover:bg-accent"
              }`}
            >
              <div
                className={`flex h-10 w-10 items-center justify-center rounded-lg ${
                  isSelected ? "bg-primary/20" : "bg-muted"
                }`}
              >
                <Icon className={`h-5 w-5 ${isSelected ? "text-primary" : "text-muted-foreground"}`} />
              </div>
              <div>
                <h4 className="font-semibold text-foreground">{game.name}</h4>
                <p className="text-xs text-muted-foreground">{game.description}</p>
                <p className="mt-1 text-[10px] text-muted-foreground">
                  {game.minPlayers}-{game.maxPlayers} players per team
                </p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}